<template lang="pug">
.report-root
    general-title(
        title="子目录",
        description="汇总与分析具有相同特征的页面，助您了解该类页面的详细数据",
        pos="right",
        :date="timeSpan"
    )

    timeSpan(@change="onTimespanChange")

    .zone
        TableTitle(icon="fa fa-list", title="数据详情")
            div.addSubMenu-btn
              a.btn.btn-icon.pull-right(@click="addSubMenu") 
                i.fa.fa-plus-circle
                | 添加子目录
        
        table.data-table.menu-table
            thead
                tr
                    th(width="40")
                    th 子目录
                    th.right 浏览量(PV)
                    th.right 访客数(UV)
                    th.right 访问次数
                    th.right 平均访问时长
                    th.right 跳出率
                    th 历史记录
                    th  操作
            tbody
                template(
                    v-for="(item, index) in subMenuTableList"
                )
                    tr.menu(
                        v-show="!isListLoading && subMenuTableList.length",
                        @click="getSubMenuList(item)"
                    )
                        td
                            b.arrow-r {{item.expanded ? '▾' : '▸'}}
                        td {{item.dir}}
                        td.right {{item.pv | number}}
                        td.right {{item.uv | number}}
                        td.right {{item.vnum | number}}
                        td.right {{item.atime | atimeFilter}}
                        td.right {{item.jrate | percent}}
                        td(@click.prevent="subMenuInfoView($event, item)") 查看详情
                        td 
                          i.fa.fa-trash(@click.prevent="removeSubMenu($event, item)")

                    tr.sub-menu(v-for="menu in item.menuList", v-show="item.expanded")
                        td
                        td {{menu.url}}
                        td.right {{menu.pv | number}}
                        td.right {{menu.uv | number}}
                        td.right {{menu.vnum | number}}
                        td.right {{menu.atime | atimeFilter}}
                        td.right {{menu.jrate | percent}}
                        td
                        td

                tr(v-show="!isListLoading && subMenuTableList.length === 0")
                    td(colspan="9", style="text-align: center;") 暂无数据
                tr(v-show="isListLoading")
                    td(colspan="9", style="text-align: center;")
                        img(src="//p.ssl.qhimg.com/t010aba4345b02168d6.gif")
        v-pagination(
            :total="subMenuListTotal",
            :pn="pageNum",
            ps="10",
            v-if="subMenuListTotal > 10",
            @updatepage="getSubMenuTable"
        )
    v-modal(:visible="menuSettingVisible",
            :title = "modalTitle",
            @closemodal="menuInfoReset")
      .modal-bd(v-if="modalTitle == '历史数据'")
        .modal-table
          table.data-table
            thead
              tr
                th 日期
                th 浏览量(PV)
                th 访客数(UV)
                th 访问次数
                th 平均访问时长
                th 跳出率
            tbody
              tr(v-if="historyList.length == 0")
                td(colspan="6") 无相关数据
              tr(v-if="historyList.length != 0" v-for="item in historyList")
                td {{item.date}}
                td {{item.pv | number}}
                td {{item.uv | number}}
                td {{item.vnum | number}}
                td {{item.atime | atimeFilter}}
                td {{item.jrate | percent}}

      .modal-bd(v-if="modalTitle == '添加子目录'")
        .modal-content
          v-form(
            v-model="menuInfo",
            ref="menuform",
            style="min-width: 500px;")
            .item
              .label 目录url：
              .control
                v-input(
                  v-model="menuInfo.url",
                  :rules="rules.url",
                  ref="menuInfoUrl")
            .item
              .label 匹配类型：
              .control
                v-radio-group(
                  v-model="menuInfo.type",
                  name="type",
                  v-bind:options="menuTypeOptions")
            .item
              .label.center
                button.btn.btn-primary.btn-small(@click.prevent="addMenuSubmit") 确认
                button.btn.btn-default.btn-small(
                  type = "reset",
                  @click.prevent="menuInfoReset"
                ) 取消

</template>
<script>
  /* global _ */
  import { getDateString } from '../../script/util'
  export default {
    data () {
      const today = getDateString(new Date())
      return {
        timeSpan: {
          start: today,
          end: today
        },
        pageNum: 1,
        subMenuListTotal: 0,
        subMenuTableList: [],
        historyList: [],
        isListLoading: false,
        menuSettingVisible: false,
        modalTitle: '',
        menuInfo: {
          url: '',
          type: 1
        },
        menuTypeOptions: [
          {
            value: 1,
            title: '完全匹配'
          }, {
            value: 2,
            title: '模糊匹配'
          }
        ]
      }
    },
    filters: {
      percent (value) {
        if (_.isNull(value)) {
          return '-'
        } else {
          return (value * 100).toFixed(2) + '%'
        }
      },
      number (value) {
        if (_.isNull(value)) {
          return '-'
        } else {
          return parseFloat(value)
        }
      },
      atimeFilter (value) {
        if (isNaN(parseFloat(value))) {
          return '-'
        }
        const t = Math.ceil(value)
        let h = 0
        let m = 0
        let i = 0
        i = t % 60
        if (t / 60 >= 1) {
          m = parseInt((t % 3600) / 60)
        }
        if (m) {
          h = parseInt(t / 3600)
        }
        return (h < 10 ? ('0' + h) : h) + ':' + (m < 10 ? ('0' + m) : m) + ':' + (i < 10 ? ('0' + i) : i)
      }
    },
    computed: {
      rules () {
        return {
          url: {
            required: true,
            pattern: /^(?:htt(?:p|ps)\:\/\/|)((?:(?:(?:\w[\.\-\+]*))\w)*)((?:(?:(?:\w[\.\-\+]*){0,62})\w)+)\.([a-z]{2,6})(?:\/[^\s<>]*|)$/i,
            maxlength: 600
          }
        }
      },
      domainId () {
        return this.$store.state.domainId
      },
      uiError () {
        return this.$store.state.uiError
      },
      query () {
        return {
          cycle: this.$store.state.start === this.$store.state.end ? 'hour' : 'day',
          domainId: this.domainId,
          start: this.$store.state.start,
          end: this.$store.state.end,
          pg: this.pageNum,
          ps: 10,
          pvtype: 0,
          timeSpan: new Date().getTime()
        }
      }
    },
    watch: {
      uiError () {
        this.$Modal.warn(this.uiError.errMsg)
      },
      domainId () {
        this.getSubMenuTable()
      }
    },
    methods: {
      onTimespanChange ({ start, end }) {
        this.timeSpan = { start, end }
        this.getSubMenuTable()
      },
      getSubMenuTable (pn = 1) {
        if (!this.domainId) return
        this.isListLoading = true
        this.pageNum = pn
        this.subMenuTableList = []

        const subMenuPromise = this.$http.get('/api/dir/list', {params: this.query})
        this.$store.dispatch('VUE_HTTP', [subMenuPromise])
          .then((res) => {
            if (res) {
              this.isListLoading = false
              this.subMenuTableList = res.list.map(item => {
                item.menuList = []
                item.expanded = false
                return item
              })
              this.subMenuListTotal = res.total || 0
            }
          })
      },
      getSubMenuList (item) {
        if (item.expanded) {
          item.expanded = false
          return
        }

        if (item.menuList.length) {
          item.expanded = true
          return
        }

        const params = _.pick(this.query, ['cycle', 'domainId', 'start', 'end', 'timespan'])
        params.id = item.id
        const menulistPromise = this.$http.get('/api/dir/listsub', {params: params})
        this.$store.dispatch('VUE_HTTP', [menulistPromise])
          .then((res) => {
            if (res) {
              item.menuList = res.list
              item.expanded = true
            }
          })
      },
      addSubMenu () {
        this.modalTitle = '添加子目录'
        this.menuSettingVisible = true
        this.$nextTick(() => {
          this.$refs.menuInfoUrl.$el.querySelector('input').focus()
        })
      },
      removeSubMenu (evt, item) {
        evt.stopPropagation()
        this.$Modal.confirm('删除该记录？', result => {
          if (!result) return
          const params = {
            cycle: this.query.cycle,
            domainId: this.domainId,
            id: item.id,
            timespan: new Date().getTime()
          }
          const deletePromise = this.$http.get('/api/dir/delete', {params: params})
          this.$store.dispatch('VUE_HTTP', [deletePromise])
            .then((res) => {
              if (res) {
                this.getSubMenuTable()
              }
            })
        })
      },
      subMenuInfoView (evt, menu = {}) {
        evt.stopPropagation()
        this.modalTitle = '历史数据'
        const params = _.assignIn({}, this.query, {ps:1000, id: menu.id})
        const infoPromise = this.$http.get('/api/dir/history', {params: params})
        this.$store.dispatch('VUE_HTTP', [infoPromise])
          .then((res) => {
            if (res) {
              this.historyList = res.list
              this.menuSettingVisible = true
            }
          })
      },
      menuInfoReset () {
        this.menuInfo = _.cloneDeep({
          url: '',
          type: 1
        })
        this.historyList = []
        this.$refs.menuform && this.$refs.menuform.resetValidity()
        this.menuSettingVisible = false
      },
      addMenuSubmit () {
        if (!this.$refs.menuInfoUrl.validate().valid) return
        const params = {
          cycle: this.query.cycle,
          domainId: this.domainId,
          url: this.menuInfo.url,
          matchtype: this.menuInfo.type,
          timespan: new Date().getTime()
        }
        const addPromise = this.$http.get('/api/dir/add', {params: params})
        this.$store.dispatch('VUE_HTTP', [addPromise])
          .then((res) => {
            if (res) {
              this.menuSettingVisible = false
              this.menuInfoReset()
              this.getSubMenuTable()
            }
          })
      }
    }
  }
</script>
<style scoped>
.addSubMenu-btn {
  display: inline-block;
  float: right;
  font-size: 12px;
  margin-top: 12px;
}
.zone header {
  padding-right: 1em;
}
.center {
  text-align: center;
}
.modal-table {
  padding: 10px 10px 30px; 
  min-width: 600px;
  max-height: 550px;
  overflow-y: auto;
  &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
  }
  &::-webkit-scrollbar-thumb {
      background: #ced3d9;
      border-radius: 10px;
      border-radius: 30px;
  }
  &::-webkit-scrollbar-track {
      background: #eaeced;
  }
}
.arrow-r {
  display: inline-block;
  width: 14px;
  height: 14px;
  font-size: 14px;
  text-align: right;
  color: #999;
}

.data-table tr td,
.data-table tr th {
  padding: 0 15px;
}
.data-table tbody tr.menu {
  background: #fff;
  cursor: pointer;
}
.data-table tbody tr.sub-menu {
  background: #f5f5f5;
  & td:nth-child(2) {
      text-indent: 1em;
  }
}

</style>



// WEBPACK FOOTER //
// subdir.vue?5a1af6dc